import { jsxs as n, jsx as e } from "react/jsx-runtime";
const s = ({
  size: o = 80,
  color: r = "currentColor",
  ...t
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 80 80",
    fill: "none",
    ...t,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M73.3337 36.9527V40.0194C73.3296 47.2075 71.002 54.2017 66.6981 59.9588C62.3942 65.716 56.3446 69.9277 49.4515 71.9657C42.5584 74.0038 35.1912 73.7591 28.4486 71.268C21.7059 68.777 15.9492 64.1731 12.0369 58.143C8.12455 52.1129 6.2663 44.9796 6.73925 37.8071C7.2122 30.6346 9.99102 23.8072 14.6613 18.343C19.3315 12.8788 25.6429 9.07068 32.6543 7.48656C39.6656 5.90244 47.0012 6.62719 53.567 9.55274",
          stroke: r,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M73.3333 13.333L40 46.6997L30 36.6997",
          stroke: r,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  s as CheckCircleBrokenIcon
};
